import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { siteMeta, categories } from '../../mocks/site';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const go = (path: string) => {
    navigate(path);
    setOpen(false);
  };

  const links = [
    { label: '首页', path: '/' },
    ...categories.slice(0, 4).map((c) => ({ label: c.name, path: `/column/${c.slug}` })),
    { label: '关于我们', path: '/about' },
  ];

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-100/95 backdrop-blur-md shadow-[0_1px_0_0_oklch(var(--background-200))]' : 'bg-transparent'
      }`}
    >
      <div className="container-x flex h-16 items-center justify-between md:h-[72px]">
        <button
          onClick={() => go('/')}
          className="flex cursor-pointer items-center gap-2.5"
          aria-label="回到首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-lg text-background-50">
            <i className="ri-archive-fill"></i>
          </span>
          <span className="font-display text-lg font-bold tracking-wide text-foreground-900 md:text-xl">
            {siteMeta.name}
            <span className="ml-2 hidden align-middle text-xs font-normal text-accent-700 sm:inline">
              {siteMeta.slogan}
            </span>
          </span>
        </button>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {links.map((l) => (
            <button
              key={l.path}
              onClick={() => go(l.path)}
              className={`cursor-pointer whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                location.pathname === l.path
                  ? 'bg-background-200/80 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-200/60 hover:text-foreground-900'
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <button
            onClick={() => go('/about#tougao')}
            className="cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-megaphone-line mr-1.5"></i>投稿爆料
          </button>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-800 md:hidden"
          aria-label={open ? '关闭菜单' : '打开菜单'}
        >
          <i className={`text-2xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-100 md:hidden">
          <nav className="container-x flex flex-col gap-1 py-3" aria-label="移动端导航">
            {links.map((l) => (
              <button
                key={l.path}
                onClick={() => go(l.path)}
                className="cursor-pointer rounded-md px-3 py-2.5 text-left text-base text-foreground-800 hover:bg-background-200"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => go('/about#tougao')}
              className="mt-1 cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-3 py-2.5 text-center text-base font-medium text-background-50"
            >
              <i className="ri-megaphone-line mr-1.5"></i>投稿爆料
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}